import { useMutation } from '@tanstack/react-query'
import { syncPurseAffiliations } from '@/queries/program_purses/requests.ts'
import { ApiCallResult } from '@/lib/tanstack-utils.types.ts'
import { ProgramPurseAffiliationsResponse } from '@/queries/program_purses/schemas.ts'

type SyncParams = { purse_id: number; program_id: number }

type SyncPayload = {
  affiliation_ids: number[]
}

async function syncPurseAffiliationsRequest(
  params: SyncParams,
  payload: SyncPayload
) {
  return syncPurseAffiliations({
    purseId: params.purse_id,
    programId: params.program_id,
    affiliationIds: payload.affiliation_ids,
  })
}

type SyncRequest = {
  params: SyncParams
  payload: SyncPayload
}

export const useSyncPurseAffiliations = (): ApiCallResult<
  ProgramPurseAffiliationsResponse,
  SyncRequest
> => {
  return useMutation({
    mutationFn: async ({ params, payload }: SyncRequest) =>
      await syncPurseAffiliationsRequest(params, payload),
  })
}
